import api from "./api";

interface OrderReport {
    name: string,
    apartmentBlock: string,
    apartmentNumber: string,
    paymentOption: string,
    paymentDate: string,
    installment: number,
    item: string,
    price: number,
}

function GetInstallment(order: OrderReport) {
    if (order.installment == null) {
        return "N/A"
    }
    return (order.installment === 1 ? "À vista" : `Parcelado ${order.installment}x`);
}

export async function DownloadOrdersReport(enterpriseId: number)
{
    const result = await api.get(`/enterprises/${enterpriseId}/report`)
    const rows: OrderReport[] = result.data.report;

    console.log(rows);

    let csvContent = "data:text/csv;charset=utf-8," + [
        ["QTDE", "Empreendimento", "Nome", "Bloco", "Apt.", "Opção de pagto", "Parcelamento", "Data de pagto", "Item", "Preço"],
        ...rows.map(order => [
            "1",
            result.data.enterpriseName,
            order.name,
            order.apartmentBlock || "N/A",
            order.apartmentNumber || "N/A",
            order.paymentOption || "N/A",
            GetInstallment(order),
            order.paymentDate || "N/A",
            order.item,
            order.price ? order.price.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }) : "Sem Custo",
        ])
    ].map(e => e.join(";")).join("\n")

    console.log(csvContent);

    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a")
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${result.data.enterpriseName} ${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
}